import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/landing/HomeView.vue'
import TestPreparationView from '../views/TestPreparationView.vue'
import CollegeCounselingView from '../views/CollegeCounselingView.vue'
import CreateMeetingView from '../views/CreateMeetingView.vue'
import BrowseCounselorsView from '../views/landing/BrowseCounselors.vue'
import PricingView from '../views/PricingView.vue'
import CareersView from '../views/landing/CareersView.vue'
import SignUpView from '../views/auth/SignUpView.vue'
import MyMessagesView from '../views/MyMessagesView.vue'
import MyScheduleView from '../views/MyScheduleView.vue'
import MeetingsPageView from '../views/MeetingsPageView.vue'
import BuyBillingView from '../views/BuyBillingView.vue'
import HowItWorksView from '../views/landing/HowItWorksView.vue'
// import BrowseCounselorsAuth from '../views/BrowseCounselorsAuth.vue'
import AddCounselorView from '../views/AddCounselorView.vue'
import LoginView from '../views/auth/LoginView.vue'

import Auth from '../auth/auth.js'
import CounselorScheduleView from '@/views/CounselorScheduleView.vue'
import UserProfileView from '@/views/UserProfileView.vue'
import EditProfileView from '../views/EditProfile.vue'; 

import AcceptMeeting from '../views/AcceptMeeting.vue'
import PaymentSuccess from '../views/payment/PaymentSuccess.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/test-preparation',
    name: 'test-preparation',
    component: TestPreparationView
  },
  {
    path: '/college-counseling',
    name: 'college-counseling',
    component: CollegeCounselingView
  },
  {
    path: '/browse-counselors',
    name: 'browse-counselors',
    component: BrowseCounselorsView
  },
  {
    path: '/create-meeting/',
    name: 'create-meeting',
    component: CreateMeetingView
  },
  // {
  //   path: '/browse-counselors-auth',
  //   name: 'browse-counselors-auth',
  //   component: BrowseCounselorsAuth
  // },
  {
    path: '/pricing',
    name: 'pricing',
    component: PricingView
  },
  {
    path: '/careers',
    name: 'careers',
    component: CareersView
  },
  {
    path: '/auth/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/auth/sign-up',
    name: 'sign-up',
    component: SignUpView
  },
  {
    path: '/messages',
    name: 'messages',
    component: MyMessagesView,
  },
  {
    path: '/meetings-page',
    name: 'meetings-page',
    component: MeetingsPageView
  },
  {
    path: '/edit-profile',
    name: 'edit-profile',
    component: EditProfileView
  },
  {
    path: '/schedule',
    name: 'schedule',
    // If the user is not authenticated, redirect to the login page
    beforeEnter: (to, from, next) => {
      if (Auth.isAuthenticated()) {
        // If user is a counselor, redirect to the counselor schedule page
        if (Auth.getUserType() === 'counselor') {
          next('/counselor-schedule')
        } else {
          next('/user-schedule')
        }
      } else {
        next('/login')
      }
    }, 
  },
  {
    path: '/user-schedule',
    name: 'user-schedule',
    component: MyScheduleView
  },
  {
    path: '/counselor-schedule',
    name: 'counselor-schedule',
    component: CounselorScheduleView
  },
  {
    path: '/buy-billing',
    name: 'buy-billing',
    component: BuyBillingView
  },
  {
    path: '/how-it-works',
    name: 'how-it-works',
    component: HowItWorksView
  },
  {
    path: '/add-counselor',
    name: 'add-counselor',
    component: AddCounselorView
  },
  {
    path: '/profile/:counselor_user_id',
    name: 'profile',
    component: UserProfileView
  },
  {
    path: '/meeting-details',
    name: 'meeting-details',
    component: AcceptMeeting
  },
  {
    path: "/payment/success",
    name: "PaymentSuccess",
    component: PaymentSuccess,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
